import { createRouter, createWebHistory } from 'vue-router';
import ProductList from '../views/ProductList.vue';
import ProductDetail from '../views/ProductDetail.vue';

const routes = [
    {
        path: '/',
        name: 'ProductList',
        component: ProductList,
        props: route => ({ category: route.query.category })
    },
    {
        path: '/product/:category/:id',
        name: 'ProductDetail',
        component: ProductDetail,
        props: true
    },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;